import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AddressTypeOption, ADDRESS_TYPE_OPTIONS } from 'src/app/core/constants';
import { AddressType, PatientAddress, ReorderDetails } from 'src/app/core/models';
import { AddPatientAddressType } from 'src/app/core/store/addresses/addresses.actions';
import { AddressesState } from 'src/app/core/store/addresses/addresses.state';
import { SetContactsUserData } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.actions';
import { ContactsUserData } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.model';
import { OrderWizardDataState } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.state';
import { ApiStoreData, CcsSentryError } from 'src/app/core/store/utils';
import { asFormControl } from 'src/app/core/utils/common';
import { validateAllFormFields } from 'src/app/core/utils/validators';

@Component({
  selector: 'app-contacts-step',
  templateUrl: './contacts-step.component.html',
  styleUrls: ['./contacts-step.component.scss'],
})
export class ContactsStepComponent implements OnInit {
  @Select(OrderWizardDataState.isContactsStepLoading) isContactsStepLoading$!: Observable<boolean>;
  @Select(OrderWizardDataState.contactsStepErrors) contactsStepErrors$!: Observable<CcsSentryError[] | null>;
  @Select(OrderWizardDataState.reorder) reorder$!: Observable<ReorderDetails>;
  @Select(OrderWizardDataState.addresses) addresses$!: Observable<PatientAddress[]>;
  @Select(OrderWizardDataState.contactsUserData) contactsUserData$!: Observable<ContactsUserData>;
  @Select(AddressesState.addPatientAddressTypeState) addPatientAddressTypeState$!: Observable<ApiStoreData<null>>;
  @Select(OrderWizardDataState.isBillingStepLoading) isBillingStepLoading$!: Observable<boolean>;

  editMode: boolean = false;

  shippingAddressForm = new FormGroup({
    selectedAddressId: new FormControl(null, [Validators.required]),
  });

  initialValues: ContactsUserData = {
    selectedAddressId: null,
  };

  displayModal: boolean = false;
  showErrors: boolean = false;

  asFormControl = asFormControl;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.reorder$.subscribe((reorder) => {
      const currentSelection = this.shippingAddressForm.value.selectedAddressId;

      if (!currentSelection) {
        const selectedAddressId = reorder?.shippingAddress?.id || null;
        this.shippingAddressForm.patchValue({ selectedAddressId });
        this.initialValues.selectedAddressId = selectedAddressId;
      }
    });
  }

  getAddressTypeOptions() {
    return ADDRESS_TYPE_OPTIONS;
  }

  mapAddressTypeValuesToTagLabels(values: string[]) {
    return ADDRESS_TYPE_OPTIONS.filter((o: AddressTypeOption) => values.includes(o.value)).map((o) => o.tagLabel);
  }

  changeSelectedAddress(addressId: number) {
    this.shippingAddressForm.patchValue({
      selectedAddressId: addressId,
    });
  }

  addAddressDefault(e: any, addressId: number, addressType: AddressType) {
    this.store.dispatch(new AddPatientAddressType(addressId, addressType));
  }

  switchToEdit() {
    this.editMode = true;
  }

  endEdit() {
    this.editMode = false;
  }

  onCancelshippingAddressForm() {
    this.endEdit();
    this.shippingAddressForm.setValue(this.initialValues);
    this.showErrors = false;
  }

  onSubmitshippingAddressForm() {
    if (this.shippingAddressForm.valid) {
      this.store.dispatch(new SetContactsUserData(this.shippingAddressForm.value));
      this.initialValues = this.shippingAddressForm.value;
      this.endEdit();
    } else {
      validateAllFormFields(this.shippingAddressForm);
      this.showErrors = true;
    }
  }

  showModal() {
    this.displayModal = true;
  }

  hideModal() {
    this.displayModal = false;
  }

  onAddressCreated(newAddressId: number) {
    this.switchToEdit(); // Done to handle single address case
    this.shippingAddressForm.get('selectedAddressId')?.setValue(newAddressId);
  }
}
